import { SemanticArticle } from '@shared/types/mylounge';

export interface State {
    title: string;
    articles: SemanticArticle[];
    loading: boolean;
    error?: string;
    themeHash?: string;
    totalCount: number;
}

export const initialState: State = {
    title: '',
    articles: [],
    loading: false,
    error: undefined,
    themeHash: '',
    totalCount: 0,
};
